var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.994,
    height: 55.989,
    viewBox: "0 0 55.994 55.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 55.994,
    height: 55.989,
    transform: "translate(0 0)",
    fill: "#0d0b0e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2557",
    "data-name": "Groupe 2557",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2559",
    "data-name": "Groupe 2559",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_886",
    "data-name": "Trac\\xE9 886",
    d: "M16.848,0a3.82,3.82,0,0,0-1.573.338,3.755,3.755,0,0,0-2.124,2.734,9.576,9.576,0,0,0-.073,1.863c0,.14.007.285.009.428l0,.227L7.64,5.642a6.514,6.514,0,0,0-2.309.537A8.5,8.5,0,0,0,.744,10.554,8.929,8.929,0,0,0,0,14.226V47.339a8.956,8.956,0,0,0,.677,3.533A8.493,8.493,0,0,0,5.115,55.31a8.9,8.9,0,0,0,3.51.677H47.563a8.534,8.534,0,0,0,5.328-1.894,8.307,8.307,0,0,0,2.057-2.473,8.458,8.458,0,0,0,.987-3.063,12.66,12.66,0,0,0,.06-1.527V15.155q0-.19,0-.38c0-.248,0-.5,0-.758a8.509,8.509,0,0,0-2.013-5.465,8.27,8.27,0,0,0-2.444-1.96,8.626,8.626,0,0,0-2.99-.941l-.014,0-.014,0h-.066l-5.479-.054,0-.225q0-.2,0-.4c.006-.462.013-.937-.011-1.4A3.791,3.791,0,0,0,41.185.547,3.726,3.726,0,0,0,39.448.005a3.822,3.822,0,0,0-1.792.331,3.755,3.755,0,0,0-2.123,2.734,9.575,9.575,0,0,0-.073,1.862c0,.14.007.284.009.426l0,.229H20.594l0-.227c0-.129,0-.258,0-.388V4.96c.006-.46.013-.935-.011-1.4A3.791,3.791,0,0,0,18.8.547,3.725,3.725,0,0,0,17.068.005Q16.958,0,16.848,0M46.97,54.077H8.533a6.8,6.8,0,0,1-2.724-.558,6.439,6.439,0,0,1-2.257-1.631A6.728,6.728,0,0,1,1.91,47.321v-30.5H51.986c.225,0,.455.006.678.011.391.01.794.019,1.182,0l.237-.012V43.777c0,.415,0,.837-.01,1.245v0c-.009.817-.019,1.662.009,2.488,0,.015,0,.029,0,.044v.016a6.558,6.558,0,0,1-1.225,3.771,6.413,6.413,0,0,1-3.172,2.381,8.147,8.147,0,0,1-2.716.351M1.911,14.915l0-.317c0-.294,0-.6.009-.9a6.446,6.446,0,0,1,.5-2.209A6.551,6.551,0,0,1,5.352,8.273a5.8,5.8,0,0,1,2.112-.7,3.98,3.98,0,0,1,.4-.009c.062,0,.125,0,.185,0L13.09,7.5l0,.23q0,.2,0,.392c0,.447-.01.908.007,1.359a3.792,3.792,0,0,0,1.773,3.052,3.726,3.726,0,0,0,1.976.556,3.814,3.814,0,0,0,1.578-.341,3.754,3.754,0,0,0,2.12-2.765,9.943,9.943,0,0,0,.067-1.83c0-.132-.007-.28-.009-.424l0-.229H35.471l0,.227q0,.2,0,.4c0,.447-.01.908.007,1.358a3.792,3.792,0,0,0,1.773,3.052,3.725,3.725,0,0,0,1.975.556,3.815,3.815,0,0,0,1.578-.341,3.754,3.754,0,0,0,2.12-2.765,9.945,9.945,0,0,0,.067-1.83V8.144c0-.136-.007-.276-.009-.413l0-.232,4.748.064h.246c.169,0,.343,0,.516.01a5.113,5.113,0,0,1,1.7.475,6.579,6.579,0,0,1,3.176,2.977,6.467,6.467,0,0,1,.7,2.409c.033.389.03.782.027,1.162H53.86l.226,0,0,.316H4.007c-.224,0-.454-.006-.676-.011h0c-.221-.005-.45-.011-.676-.011-.188,0-.354,0-.507.012Zm37.3-3.732q-.063,0-.127,0a1.848,1.848,0,0,1-1.412-.847,1.9,1.9,0,0,1-.289-1.045V3.745a1.843,1.843,0,0,1,3.575-.628,2.232,2.232,0,0,1,.11.768V7.947q0,.229,0,.458,0,.458,0,.917a1.862,1.862,0,0,1-1.856,1.861m-22.38,0q-.063,0-.127,0a1.849,1.849,0,0,1-1.413-.847A1.9,1.9,0,0,1,15,9.287V3.745a1.843,1.843,0,0,1,3.575-.627,2.232,2.232,0,0,1,.11.768V7.947q0,.2,0,.392V8.4q0,.458,0,.917a1.861,1.861,0,0,1-1.855,1.861",
    transform: "translate(0 0.001)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 3.826,
    height: 3.826,
    transform: "translate(10.353 24.19)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 3.826,
    height: 3.826,
    transform: "translate(20.526 24.19)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 3.826,
    height: 3.826,
    transform: "translate(31.422 24.19)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 3.826,
    height: 3.826,
    transform: "translate(41.818 24.19)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 3.826,
    height: 3.826,
    transform: "translate(10.353 33.618)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 3.826,
    height: 3.826,
    transform: "translate(20.526 33.618)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 3.826,
    height: 3.826,
    transform: "translate(31.422 33.618)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 3.826,
    height: 3.826,
    transform: "translate(41.818 33.618)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 3.826,
    height: 3.826,
    transform: "translate(10.353 42.581)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 3.826,
    height: 3.826,
    transform: "translate(20.526 42.581)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 3.826,
    height: 3.826,
    transform: "translate(31.422 42.581)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 3.826,
    height: 3.826,
    transform: "translate(41.818 42.581)",
    fill: "#0d0b0e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.aa1a0dade79f086c0f589e43ba9ecdea.svg";
export { ForwardRef as ReactComponent };